/**
 *  <Desription of Service here>
 *
 * @export
 * @class PixiSticker
 */
export class PixiSticker {

  public sprite
  public sticker
  public loader
  public cb
  public detailCb
  public options

  constructor(options, cb, detailCb) {
    this.cb = cb
    this.detailCb = detailCb
    this.options = options
    this.loader = PIXI.loader;

    this.sticker = [options.url]
    if (this.options.isHero) {
      this.loader.add(this.sticker).load(this.stickerURLLoaded.bind(this));
    } else {
      this.stickerURLLoaded()
    }
  }

  public stickerURLLoaded() {
    let texture = PIXI.Texture.fromImage(PIXI.loader.resources[this.sticker[0]].url)
    this.sprite = new PIXI.Container()
    this.sprite.isHero = this.options.isHero
    this.sprite.name = this.options.name
    this.sprite.shouldDelete = false
    this.sprite.texture = new PIXI.Sprite(texture)
    // this.sprite.texture.scale.set(this.options.scale.x, this.options.scale.y)
    this.sprite.texture.width = this.options.width
    this.sprite.texture.height = this.options.height
    this.sprite.addChild(this.sprite.texture)

    this.sprite.rotation = this.options.rotation
    this.sprite.interactive = true;
    this.sprite.interacting = false;
    this.sprite.buttonMode = true;
    this.sprite.startScale = 1;
    this.sprite.previousScale = 1;
    this.sprite.position.x = this.options.x;
    this.sprite.position.y = this.options.y;
    this.sprite.dragging = false;
    this.sprite.rotating = false;
    this.sprite.resizing = false;

    this.sprite.controls = new PIXI.Container();
    this.sprite.controls.alpha = 0;
    this.sprite.controls.boundingBox = new PIXI.Graphics();
    this.drawControlBox(this.sprite, false)
    this.sprite.controls.addChild(this.sprite.controls.boundingBox);
    this.sprite.addChild(this.sprite.controls);

    this.attachEvents(this.options.isTouchCapable);
    this.setupRotateHandler(this.options.isTouchCapable);
    this.setupResizeHandler(this.options.isTouchCapable);

    if (!this.options.isHero) {
      this.setupTrashHandler(this.options.isTouchCapable);
    }
    if (this.options.isHero){
      this.sprite.interactive = false;
    }
    this.cb()
    this.reportDetails()
  }


  public attachEvents(isTouchCapable: boolean = false) {
    if (!this.options.isHero){
      if (!isTouchCapable) {
        this.sprite.on('mousedown', event => { this.onSpriteDragStart(event, this.options.container) })
        this.sprite.on('mousemove', event => { this.onSpriteDragMove(event, this.options.container) })
        this.sprite.on('mouseup', event => { this.onSpriteDragEnd(event, this.options.container) })
        this.sprite.on('mouseupoutside', event => { this.onSpriteDragEnd(event, this.options.container) })
        this.sprite.on('mouseover', event => { this.showControls() })
        this.sprite.on('mouseout', event => { this.hideControls() })
        this.sprite.on('mouseupoutside', event => { this.hideControls() });
      } else {
        this.sprite.on('touchstart', event => {
          this.onSpriteDragStart(event, this.options.container)
        })
        this.sprite.on('touchmove', event => {
          this.onSpriteDragMove(event, this.options.container)
        })
        this.sprite.on('touchend', event => {
          this.onSpriteDragEnd(event, this.options.container)
        })
        this.sprite.on('touchendoutside', event => {
          this.onSpriteDragEnd(event, this.options.container)
        })
        this.sprite.on('touchstart', event => {
          this.checkControlsShowing(this.sprite.parent.children)
          this.showControls()
          this.sprite.controls.alpha = 1;
        })
      }
    }
  }

  public onSpriteDragStart(event, container) {
    this.options.element.isStickerInteraction = true
    let sprite = event.target
    sprite.dragging = true;
    container.bringToFront(sprite);
    sprite.originPoint = event.data.getLocalPosition(container);
    sprite.offset = new PIXI.Point(sprite.originPoint.x - sprite.position.x, sprite.originPoint.y - sprite.position.y);
  }

  public onSpriteDragMove(event, container) {
    let sprite = event.target
    if (sprite.dragging && sprite.rotating === false && sprite.resizing === false) {
      let newPoint: PIXI.Point = event.data.getLocalPosition(container);
      let canvasContainer:any  = document.querySelector('.comic-screen__cover__container__cover');
      newPoint.set(newPoint.x - sprite.offset.x, newPoint.y - sprite.offset.y);
      if (newPoint.x > 0 && newPoint.y > 0 && newPoint.x < 954 && newPoint.y < 1458){
        sprite.position = newPoint;
        sprite.controls.alpha = 1
      }
    }
  }

  public onSpriteDragEnd(event, container) {
    event.target.dragging = false;
    this.options.element.isStickerInteraction = false
    this.reportDetails()
  }

  public setupRotateHandler(isTouchCapable: boolean = false) {
    if (!this.options.isHero){
      this.sprite.controls.handlerRotate = new PIXI.Container();
      this.sprite.controls.handlerRotate.interactive = true;
      this.sprite.controls.handlerRotate.texture = PIXI.Sprite.fromImage(this.options.controlIconPaths.rotate);
      this.sprite.controls.handlerRotate.texture.width = 84.4;
      this.sprite.controls.handlerRotate.texture.height = 101.3;
      this.sprite.controls.handlerRotate.addChild(this.sprite.controls.handlerRotate.texture);
      this.sprite.controls.handlerRotate.position.x = Math.abs(this.sprite.texture.width) - this.sprite.controls.handlerRotate.width / 2
      this.sprite.controls.handlerRotate.position.y = 0 - this.sprite.controls.handlerRotate.height / 2

      if (!isTouchCapable) {
        this.sprite.controls.handlerRotate
          .on('mousedown', event => { this.onSpriteRotateStart(this.sprite, event) })
          .on('mousemove', event => { this.onSpriteRotateMove(this.sprite, event) })
          .on('mouseup', event => { this.onSpriteRotateEnd(this.sprite, event) })
          .on('mouseupoutside', event => { this.onSpriteRotateEnd(this.sprite, event) });
      } else {
        this.sprite.controls.handlerRotate
          .on('touchstart', event => { this.onSpriteRotateStart(this.sprite, event) })
          .on('touchmove', event => { this.onSpriteRotateMove(this.sprite, event) })
          .on('touchend', event => {
            this.onSpriteRotateEnd(this.sprite, event)
          })
          .on('touchendoutside', event => {
            this.onSpriteRotateEnd(this.sprite, event)
          });
      }
      this.sprite.controls.addChild(this.sprite.controls.handlerRotate);
    }
  }

  public onSpriteRotateStart(topSprite, event) {
    topSprite.rotating = true;
    this.options.element.isStickerInteraction = true
    topSprite.rotateStartX = parseInt(event.data.global.x);
    topSprite.rotateStartY = parseInt(event.data.global.y);
  }

  public onSpriteRotateMove(topSprite, event) {
    if (topSprite.rotating) {
      for(let c in this.sprite.parent.children){
        this.sprite.parent.children[c].controls.alpha = 0
        this.sprite.parent.children[c].alpha = 0.6
      }
      topSprite.alpha = 1
      topSprite.controls.alpha = 1

      let targetPos = event.data.getLocalPosition(this.sprite.parent);
      let dx = targetPos.x - topSprite.position.x;
      let dy = targetPos.y  - topSprite.position.y;
      let angleRadians = Math.atan2( dy, dx );
      let angleDegrees = angleRadians * (180/Math.PI);

      if( angleDegrees < 0 ) {
          angleDegrees += 360;
      }
      topSprite.rotation = ( angleDegrees) * (Math.PI / 180);
      //topSprite.controls.handlerResize.rotation = ( angleDegrees + 90) * (Math.PI / 180);
    }
  }

  public onSpriteRotateEnd(topSprite, event) {
    for(let c in this.sprite.parent.children){
      this.sprite.parent.children[c].alpha = 1
    }
    topSprite.rotating = false;
    this.options.element.isStickerInteraction = false
    this.reportDetails()
  }

  public setupResizeHandler(isTouchCapable: boolean = false) {
    if (!this.options.isHero){
      this.sprite.controls.handlerResize = new PIXI.Container();
      this.sprite.controls.handlerResize.interactive = true;

      this.sprite.controls.handlerResize.texture = PIXI.Sprite.fromImage(this.options.controlIconPaths.resize);
      this.sprite.controls.handlerResize.texture.width = 70.7;
      this.sprite.controls.handlerResize.texture.height = 78.7;
      this.sprite.controls.handlerResize.pivot.x = 35;
      this.sprite.controls.handlerResize.pivot.y = 39;

      this.sprite.controls.handlerResize.addChild(this.sprite.controls.handlerResize.texture);

      this.sprite.controls.handlerResize.position.x = Math.abs(this.sprite.texture.width)
      this.sprite.controls.handlerResize.position.y = Math.abs(this.sprite.texture.height)


      if (!isTouchCapable) {
        this.sprite.controls.handlerResize
          .on('mousedown', event => { this.onSpriteResizeStart(this.sprite, this.options.element, event) })
          .on('mousemove', event => { this.onSpriteResizeMove(this.sprite, this.options.element, event) })
          .on('mouseup', event => { this.onSpriteResizeEnd(this.sprite, this.options.element, event) })
          .on('mouseupoutside', event => { this.onSpriteResizeEnd(this.sprite, this.options.element, event) });
      } else {
        this.sprite.controls.handlerResize
          .on('touchstart', event => { this.onSpriteResizeStart(this.sprite, this.options.element, event) })
          .on('touchmove', event => { this.onSpriteResizeMove(this.sprite, this.options.element, event) })
          .on('touchend', event => {
            this.onSpriteResizeEnd(this.sprite, this.options.element, event)
          })
          .on('touchendoutside', event => {
            this.onSpriteResizeEnd(this.sprite, this.options.element, event)
          });

      }
      this.sprite.controls.addChild(this.sprite.controls.handlerResize);
    }
  }

  public onSpriteResizeStart(topSprite, pixiElement, event) {
    topSprite.resizing = true;
    this.options.element.isStickerInteraction = true

      for(let c in this.sprite.parent.children){
        this.sprite.parent.children[c].controls.alpha = 0
        this.sprite.parent.children[c].alpha = 0.6
      }

      topSprite.alpha = 1
      topSprite.controls.alpha = 1

    let targetPos = event.data.getLocalPosition(this.sprite.parent);
    topSprite.resizeStartWidth = topSprite.texture.width;
    topSprite.resizeStartHeight = topSprite.texture.height;
    topSprite.resizeStartX = targetPos.x;
    topSprite.resizeStartY = targetPos.y;
  }

  public onSpriteResizeEnd(topSprite, pixiElement, event) {
    topSprite.resizing = false;
    this.options.element.isStickerInteraction = false

    for(let c in this.sprite.parent.children){
      this.sprite.parent.children[c].alpha = 1
    }
    this.reportDetails()
  }

  public onSpriteResizeMove(topSprite, pixiElement, event) {
    let mouseX, mouseY, addX, addY, adjustedPixels, adjustedPixelsX, adjustedPixelsY, resizeRatio, newWidth, newHeight;

    if (topSprite.resizing) {
      topSprite.controls.alpha = 1;

      let targetPos = event.data.getLocalPosition(this.sprite.parent);
      mouseX = targetPos.x;
      mouseY = targetPos.y;
      addX = mouseX - topSprite.resizeStartX;
      addY = mouseY - topSprite.resizeStartY;
      adjustedPixels = addX + addY;
      resizeRatio = (topSprite.resizeStartWidth + topSprite.resizeStartHeight);
      resizeRatio = (resizeRatio + (adjustedPixels * 2)) / resizeRatio;

      if( parseInt(topSprite.rotation) < 6 && parseInt(topSprite.rotation) <= 3 && topSprite.rotation !== 0) {
        newWidth = topSprite.resizeStartWidth / resizeRatio;
        newHeight = topSprite.resizeStartHeight / resizeRatio;
      }else{
        newWidth = topSprite.resizeStartWidth * resizeRatio;
        newHeight = topSprite.resizeStartHeight * resizeRatio;
      }

      if ((newWidth > 120 && (newHeight > 120)) && (newWidth < 800 && (newHeight < 800))) {
        topSprite.texture.width = newWidth;
        topSprite.texture.height = newHeight;
        this.drawControlBox(topSprite)
      }
    }
  }

  public setupTrashHandler(isTouchCapable: boolean = false) {
    this.sprite.controls.handlerTrash = new PIXI.Container();
    this.sprite.controls.handlerTrash.interactive = true;

    this.sprite.controls.handlerTrash.texture = PIXI.Sprite.fromImage(this.options.controlIconPaths.trash);
    this.sprite.controls.handlerTrash.texture.width = 79.5;
    this.sprite.controls.handlerTrash.texture.height = 89.5;

    this.sprite.controls.handlerTrash.addChild(this.sprite.controls.handlerTrash.texture);

    this.sprite.controls.handlerTrash.position.x = -1 * this.sprite.controls.handlerTrash.width / 2;
    this.sprite.controls.handlerTrash.position.y = -1 * this.sprite.controls.handlerTrash.height / 2;


    if (!isTouchCapable) {
      this.sprite.controls.handlerTrash.on('click', event => { this.deleteSticker() })
    } else {
      this.sprite.controls.handlerTrash.on('touchend', event => { this.deleteSticker() })
    }

    this.sprite.controls.addChild(this.sprite.controls.handlerTrash);
  }

  public deleteSticker() {
    this.sprite.shouldDelete = true
    this.reportDetails()
    this.options.container.removeChild(this.sprite)
  }

  public drawControlBox(sprite, positionControls = true) {

    if (positionControls) {
      sprite.controls.handlerRotate.position.x = Math.abs(sprite.texture.width) - sprite.controls.handlerRotate.width / 2
      sprite.controls.handlerRotate.position.y = 0 - sprite.controls.handlerRotate.height / 2
      sprite.controls.handlerResize.position.x = Math.abs(sprite.texture.width)
      sprite.controls.handlerResize.position.y = Math.abs(sprite.texture.height)

      if (!sprite.isHero) {
        sprite.controls.handlerTrash.position.x = -1 * sprite.controls.handlerTrash.width / 2;
        sprite.controls.handlerTrash.position.y = -1 * sprite.controls.handlerTrash.height / 2;
      }
    }

    sprite.controls.boundingBox.clear();
    sprite.controls.boundingBox.alpha = 1;
    sprite.controls.boundingBox.padding = 0;
    sprite.controls.boundingBox.position.x = 0
    sprite.controls.boundingBox.position.y = 0
    sprite.pivot.set(sprite.texture.width / 2, sprite.texture.height / 2);

    sprite.controls.boundingBox.beginFill(0x000000, 0)
      .lineStyle(1, 0x000000)
      .moveTo(-Math.abs(sprite.controls.boundingBox.padding), -Math.abs(sprite.controls.boundingBox.padding))
      .lineTo(sprite.texture.width + (sprite.controls.boundingBox.padding), -Math.abs(sprite.controls.boundingBox.padding))
      .lineTo(sprite.texture.width + (sprite.controls.boundingBox.padding), sprite.texture.height + (sprite.controls.boundingBox.padding))
      .lineTo(-Math.abs(sprite.controls.boundingBox.padding), sprite.texture.height + (sprite.controls.boundingBox.padding))
      .lineTo(-Math.abs(sprite.controls.boundingBox.padding), -Math.abs(sprite.controls.boundingBox.padding))
      .endFill();
  }

  public checkControlsShowing(sprites) {
    for (let i = 0; i < sprites.length; i++) {
      if (sprites[i] !== this.sprite) {
        sprites[i].controls.alpha = 0;
        sprites[i].interacting = false;
      }
    }
  }

  public hideControls() {
    this.sprite.controls.alpha = 0;
    this.sprite.interacting = false;
  }

  public showControls() {
    if (!this.options.element.isStickerInteraction) {
      this.sprite.interacting = true;
      this.sprite.controls.alpha = 1;
    }
  }

  public reportDetails(): void {
    let details = {
      name: this.sprite.name,
      url: this.options.url,
      width: this.sprite.texture.width,
      height: this.sprite.texture.height,
      rotation: this.sprite.rotation,
      position: this.sprite.position,
      isHero: this.sprite.isHero,
      shouldDelete: this.sprite.shouldDelete
    }
    // console.log('reportDetails', details)

    this.detailCb(details)
  }

}



/** WEBPACK FOOTER **
 ** ./src/common/services/pixi-manager/pixi-sticker.ts
 **/